<template>
  <div class="my-item">
    <div class="custom-wrap">
      <template v-if="list && list.length">
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
          <template slot-scope="{ row, index }" slot="name">
            <span class="brand">{{row.name}}</span>
          </template>
          <template slot-scope="{ row, index }" slot="nameEn">
            <span class="brand">{{row.nameEn}}</span>
          </template>
          <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
          <template slot-scope="{ row, index }" slot="action">
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <supplyAdd 
      :show="show" 
      @finish="init()" 
      @close="show=false;"
      :options="options"
      :modelTitle="modelTitle"
    />
  </div>
</template>

<script>
import supplyAdd from "../components/busType-add.vue";
// import supplyEdit from "../components/supply-edit.vue";
import { mapActions } from "vuex";

export default {
  // 主办设置
  name: "host-set",
  data() {
    return {
      list: null, 
      edit: false,
      editInfo: false,
      show: false, 
      options:{}, 
      modelTitle:'',
      columns1: [
        {
          title: "企业经营类型",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "英文类别",
          slot: "nameEn",
          key: "nameEn",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    this.init();
  },
  components: {
    supplyAdd, 
    // supplyEdit, 
  },
  methods: {
    ...mapActions({
      getBusinessTypeList:'hostSetModule/getBusinessTypeList',
      delBusType:'hostSetModule/delBusType',
    }),  
    async init() {
      let url = '/api/BusinessType/GetList';
      let listData = await this.getBusinessTypeList(url); 
      this.list = listData;
    }, 
    async delItem(item) { 
      let opt = {
         url: '/api/BusinessType',
         id:item.id
      }
      let result = await this.delBusType(opt);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() { // 新增
      this.show = true;
      this.modelTitle = '新增';
      this.options = {
        model:null,
        msg:null,
      }
    },
    editShow(item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑';
      this.options = {
        model:'edit',
        msg:item,
      }
    }
  }
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 0 auto;
  min-height: 500px;
} 
</style>
